import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%"
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    avatarContainer: {
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden"
    },
    userCardAvatar: {
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        height: 52,
        width: 52
    },
    container: {
        flexDirection: "column",
        width: "100%",
        flex: 1
    },
    profileCard: {
        flexDirection: "column",
        width: "100%"
    },
    infoContainer: {
        flexDirection: "column",
        flex: 1
    },
    detailSection: {
        flexDirection: "column",
        width: "100%"
    },
    detailCol: {
        flexDirection: "column",
        flex: 1
    },
    profileHeader: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%"
    },
    userCardContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    userCardAvatarImage: {
        height: "100%",
        width: "100%"
    },
    avatarImage: {
        height: "100%",
        width: "100%"
    },
    detailRow: {
        width: "100%"
    },
    userCardInfo: {
        flex: 1
    }
});

export default stylesheet;
